/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Substatus_Pickup_Out_For_CollectionInputs */

const tr_geliver_substatus_pickup_out_for_collection = /** @type {(inputs: Geliver_Substatus_Pickup_Out_For_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurye Yolda (Teslim Alım)`)
};

const en_geliver_substatus_pickup_out_for_collection = /** @type {(inputs: Geliver_Substatus_Pickup_Out_For_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Out for Collection`)
};

const de_geliver_substatus_pickup_out_for_collection = /** @type {(inputs: Geliver_Substatus_Pickup_Out_For_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurier unterwegs zur Abholung`)
};

const ru_geliver_substatus_pickup_out_for_collection = /** @type {(inputs: Geliver_Substatus_Pickup_Out_For_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Курьер едет за посылкой`)
};

/**
* | output |
* | --- |
* | "Out for Collection" |
*
* @param {Geliver_Substatus_Pickup_Out_For_CollectionInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_substatus_pickup_out_for_collection = /** @type {((inputs?: Geliver_Substatus_Pickup_Out_For_CollectionInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Substatus_Pickup_Out_For_CollectionInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_substatus_pickup_out_for_collection(inputs)
	if (locale === "de") return de_geliver_substatus_pickup_out_for_collection(inputs)
	if (locale === "ru") return ru_geliver_substatus_pickup_out_for_collection(inputs)
	return tr_geliver_substatus_pickup_out_for_collection(inputs)
});